var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "thumbnail",
      attrs: { id: "thumbnail" + _vm.dir, alt: _vm.dir },
      on: { click: _vm.imageClick }
    }),
    _vm._v(" "),
    _vm.vesselpic_id != undefined
      ? _c("p", { staticClass: "subtext" }, [_vm._v(_vm._s(_vm.vesselpic_id))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: { id: "myModal" + _vm.dir },
        on: { click: _vm.close }
      },
      [
        _c("img", {
          staticClass: "modal-content",
          attrs: { id: "img" + _vm.dir }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1063bf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1063bf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/vesselpic.vue
// module id = 819
// module chunks = 0